import { Injectable } from '@angular/core';
import { CompanyForm, CompanyFormModel } from '@models/company/company-form-state';
import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { ResetCompanyForm } from '@stores/company-form/company-form.actions';

const CompanyFormStateToken = new StateToken<CompanyForm>('companyForm');

@State({
  name: CompanyFormStateToken,
  defaults: {
    form: {
      model: { array: [] },
      dirty: false,
      status: '',
      errors: {},
    },
  },
})
@Injectable()
export class CompanyFormState {
  @Selector([CompanyFormState])
  static model(state: CompanyForm): CompanyFormModel {
    return state.form.model;
  }

  @Action(ResetCompanyForm)
  logout(ctx: StateContext<CompanyForm>): void {
    ctx.setState({
      form: {
        model: { array: [] },
        dirty: false,
        status: '',
        errors: {},
      },
    });
  }
}
